// Central plan + add-on metadata shared across the app.
// Keep in sync with backend PLAN_DAILY_MATCH_LIMITS in server.py.

export const PLAN_META = {
  free: {
    label: 'Free',
    icon: 'Heart',
    badgeClass: 'bg-gray-100 text-gray-700',
    pillClass: 'bg-gray-200 text-gray-700',
    matchesLabel: '5 daily matches',
    canBrowse: false,
    perks: ['5 daily matches', 'Basic messaging', 'Compatibility scores', 'Weekly reflections'],
  },
  standard: {
    label: 'Standard',
    icon: 'Star',
    badgeClass: 'bg-blue-100 text-blue-700',
    pillClass: 'bg-blue-500 text-white',
    matchesLabel: '15 daily matches',
    canBrowse: false,
    perks: ['15 daily matches', 'AI conversation starters', 'See who liked you', 'Verification badge'],
  },
  premium: {
    label: 'Premium',
    icon: 'Sparkles',
    badgeClass: 'bg-amber-100 text-amber-700',
    pillClass: 'bg-gradient-to-r from-amber-400 to-rose-400 text-white',
    matchesLabel: 'Unlimited matches',
    canBrowse: true,
    perks: ['Unlimited matches', 'Browse & search all users', 'AI date ideas', 'Red-flag detection', 'Read receipts'],
  },
  private_match: {
    label: 'Private Match',
    icon: 'Crown',
    badgeClass: 'bg-gradient-to-r from-amber-100 to-rose-100 text-amber-800',
    pillClass: 'bg-gradient-to-r from-amber-500 to-rose-500 text-white',
    matchesLabel: 'Unlimited + concierge',
    canBrowse: true,
    perks: ['Everything in Premium', '1-on-1 matchmaker', 'Handpicked matches', 'Date coaching', 'Background verification'],
  },
};

export const ADDON_META = {
  live_match: { label: 'Live Match Event', icon: 'Zap', colorClass: 'text-rose-500' },
  profile_boost: { label: 'Profile Boost', icon: 'TrendingUp', colorClass: 'text-blue-500' },
  super_likes: { label: 'Super Likes', icon: 'Heart', colorClass: 'text-purple-500' },
  background_check: { label: 'Background Check', icon: 'Shield', colorClass: 'text-green-500' },
  video_date: { label: 'Guided Video Date', icon: 'Video', colorClass: 'text-indigo-500' },
};

export const getPlanMeta = (planType) => PLAN_META[planType] || PLAN_META.free;
